var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentAttachment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "document-attachment",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.166,
    height: 29.36,
    viewBox: "0 0 25.166 29.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M31.326,33.263H15.6a2.1,2.1,0,0,1-2.1-2.1V24.874h2.1v6.291H31.326V8.1H21.889V6h9.437a2.1,2.1,0,0,1,2.1,2.1V31.166A2.1,2.1,0,0,1,31.326,33.263Z",
    transform: "translate(-8.257 -3.903)",
    fill: "#00828b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M25.5,15h7.34v2.1H25.5Z",
    transform: "translate(-11.869 -6.611)",
    fill: "#00828b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M24,22.5h8.389v2.1H24Z",
    transform: "translate(-11.417 -8.869)",
    fill: "#00828b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M22.5,30h9.437v2.1H22.5Z",
    transform: "translate(-10.966 -11.126)",
    fill: "#00828b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M11.243,20.826A5.248,5.248,0,0,1,6,15.583V4.049H8.1V15.583a3.146,3.146,0,0,0,6.291,0V6.146a1.049,1.049,0,1,0-2.1,0V16.631h-2.1V6.146a3.146,3.146,0,0,1,6.291,0v9.437A5.248,5.248,0,0,1,11.243,20.826Z",
    transform: "translate(-6 -3)",
    fill: "#00828b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentAttachment);
export default __webpack_public_path__ + "static/media/document-attachment.4365011a5b78381a0f1f7874a54e168f.svg";
export { ForwardRef as ReactComponent };